var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoArCintellicareEstesoNopaddingBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo_ARCintellicare_esteso_nopadding_1_",
    "data-name": "Logo_ARCintellicare_esteso_nopadding (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 475.1,
    height: 83.2,
    viewBox: "0 0 475.1 83.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9831",
    "data-name": "Group 9831"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12348",
    "data-name": "Path 12348",
    d: "M9,76.3C3.2,71.7,0,65.5,0,58.8S3.2,46,9,41.4a33.483,33.483,0,0,1,20.7-6.9H47.1a5.707,5.707,0,0,0,3.6-1.1,6.3,6.3,0,0,0,1.5-4.3V24.4C52.2,15,42.7,7.3,31,7.3c-7.5,0-14.3,3.1-18.2,8.3l-2.2,2.9L4.8,14.2l2.1-2.9C12.2,4.2,21.2,0,30.9,0A31.418,31.418,0,0,1,50.8,6.9c5.5,4.6,8.6,10.8,8.6,17.4V58.8c0,6.6-3.2,12.9-9,17.5a33.483,33.483,0,0,1-20.7,6.9A34.111,34.111,0,0,1,9,76.3ZM29.7,41.7A26.027,26.027,0,0,0,13.5,47c-4.1,3.2-6.3,7.4-6.3,11.8s2.2,8.6,6.3,11.8a26.027,26.027,0,0,0,16.2,5.3,26.027,26.027,0,0,0,16.2-5.3c4.1-3.2,6.3-7.4,6.3-11.8v-18a14.053,14.053,0,0,1-5.2.9Z",
    fill: "#19c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12349",
    "data-name": "Path 12349",
    d: "M77.8,83.1V31.7A32.415,32.415,0,0,1,86.4,9.4a28.7,28.7,0,0,1,21-9.4V7.2C95,7.2,85,18.2,85,31.7V83.1H77.8Z",
    fill: "#19c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12350",
    "data-name": "Path 12350",
    d: "M134.7,79.8a34.9,34.9,0,0,1-11-9c-6.4-7.8-9.9-18.5-9.9-29.1s3.5-21.4,9.9-29.2a34.65,34.65,0,0,1,11-9A28.5,28.5,0,0,1,148.4,0c10.5,0,18.7,4.2,23.9,11.2l2.1,2.9-5.8,4.3-2.1-2.9c-3.9-5.2-10.6-8.3-18.1-8.3-15.2,0-27.6,15.1-27.6,34.4s12.3,34.3,27.6,34.3c7.5,0,14.2-3.1,18.1-8.3l2.1-2.9,5.8,4.3-2.1,2.9c-5.2,7-13.8,11.2-23.9,11.2A29.468,29.468,0,0,1,134.7,79.8Z",
    fill: "#19c"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12351",
    "data-name": "Path 12351",
    d: "M392.9,79.9a10.1,10.1,0,0,1,0-16.4,15.5,15.5,0,0,1,9.7-3.2h8.2a3.132,3.132,0,0,0,1.7-.5,2.823,2.823,0,0,0,.7-2V55.6c0-4.4-4.5-8-10-8a10.611,10.611,0,0,0-8.5,3.9l-1,1.4-2.7-2,1-1.4a14.1,14.1,0,0,1,11.3-5.3,14.38,14.38,0,0,1,9.3,3.2,10.664,10.664,0,0,1,4,8.2V71.8a10.573,10.573,0,0,1-4.2,8.2,15.5,15.5,0,0,1-9.7,3.2A16.275,16.275,0,0,1,392.9,79.9Zm9.7-16.2a12.172,12.172,0,0,0-7.6,2.5,7.2,7.2,0,0,0-3,5.5,6.772,6.772,0,0,0,3,5.5,12.8,12.8,0,0,0,15.2,0,7.2,7.2,0,0,0,3-5.5V63.2a7.038,7.038,0,0,1-2.4.4Z",
    fill: "#19c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12352",
    "data-name": "Path 12352",
    d: "M470.9,47.3a10.1,10.1,0,0,1,0,16.4,15.5,15.5,0,0,1-9.7,3.2H453a3.132,3.132,0,0,0-1.7.5,2.823,2.823,0,0,0-.7,2v2.2c0,4.4,4.5,8,10,8a10.611,10.611,0,0,0,8.5-3.9l1-1.4,2.7,2-1,1.4A14.1,14.1,0,0,1,460.5,83a14.38,14.38,0,0,1-9.3-3.2,10.664,10.664,0,0,1-4-8.2V55.5a10.573,10.573,0,0,1,4.2-8.2,16.453,16.453,0,0,1,19.5,0Zm-9.7,16.2a12.172,12.172,0,0,0,7.6-2.5,7.2,7.2,0,0,0,3-5.5,6.772,6.772,0,0,0-3-5.5,12.8,12.8,0,0,0-15.2,0,7.2,7.2,0,0,0-3,5.5V64a7.038,7.038,0,0,1,2.4-.4h8.2Z",
    fill: "#19c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12353",
    "data-name": "Path 12353",
    d: "M293.7,47.3a10.5,10.5,0,0,1,0,16.8c-2.6,2.1-6.1,2.8-9.7,2.8h-7.8a4.9,4.9,0,0,1-2.7-.6v5.4c0,4.4,4.5,8,10,8a10.611,10.611,0,0,0,8.5-3.9l1-1.4,2.7,2-1,1.4a14.1,14.1,0,0,1-11.3,5.3,14.38,14.38,0,0,1-9.3-3.2,10.664,10.664,0,0,1-4-8.2V55.5a10.573,10.573,0,0,1,4.2-8.2,15.5,15.5,0,0,1,9.7-3.2A15.3,15.3,0,0,1,293.7,47.3ZM284,63.6c2.9,0,5.6-.5,7.6-2.1a7.6,7.6,0,0,0,3-5.8,7.12,7.12,0,0,0-3-5.7,12.8,12.8,0,0,0-15.2,0,7.2,7.2,0,0,0-3,5.5v5.4c0,1.1.2,1.8.7,2.1a3.39,3.39,0,0,0,2.1.6Z",
    fill: "#19c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12354",
    "data-name": "Path 12354",
    d: "M426.2,83.1V59a15.264,15.264,0,0,1,4-10.5,13.415,13.415,0,0,1,9.9-4.4v3.4c-5.8,0-10.5,5.2-10.5,11.5V83.1Z",
    fill: "#19c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12355",
    "data-name": "Path 12355",
    d: "M248.3,31.6V68.2a15.264,15.264,0,0,0,4,10.5,13.415,13.415,0,0,0,9.9,4.4V79.7c-5.8,0-10.5-5.2-10.5-11.5V31.6Z",
    fill: "#19c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12356",
    "data-name": "Path 12356",
    d: "M209.9,83.1V59a15.264,15.264,0,0,1,4-10.5,13.415,13.415,0,0,1,9.9-4.4v3.4c-5.8,0-10.5,5.2-10.5,11.5V83.1Z",
    fill: "#19c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12357",
    "data-name": "Path 12357",
    d: "M237.8,83.1h-3.4V59c0-6.3-4.7-11.5-10.5-11.5V44.1a13.749,13.749,0,0,1,9.9,4.4,15.264,15.264,0,0,1,4,10.5V83.1Z",
    fill: "#19c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12358",
    "data-name": "Path 12358",
    d: "M194.2,83.1V44h3.4V83.1Z",
    fill: "#19c"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12359",
    "data-name": "Path 12359",
    d: "M338.4,83.1V44h3.4V83.1Z",
    fill: "#19c"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12360",
    "data-name": "Path 12360",
    d: "M309.2,83.1V31.6h3.4V83.1Z",
    fill: "#19c"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12361",
    "data-name": "Path 12361",
    d: "M323.8,83.1V31.6h3.4V83.1Z",
    fill: "#19c"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12362",
    "data-name": "Path 12362",
    d: "M362.8,81.5a16.076,16.076,0,0,1-5.2-4.2,22.317,22.317,0,0,1,0-27.4,16.076,16.076,0,0,1,5.2-4.2,14.771,14.771,0,0,1,6.4-1.6,13.36,13.36,0,0,1,11.2,5.3l1,1.4-2.7,2-1-1.4a10.611,10.611,0,0,0-8.5-3.9c-7.1,0-12.9,7.1-12.9,16.2s5.8,16.1,12.9,16.1a10.611,10.611,0,0,0,8.5-3.9l1-1.4,2.7,2-1,1.3a13.764,13.764,0,0,1-11.2,5.3A13.211,13.211,0,0,1,362.8,81.5Z",
    fill: "#19c"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12363",
    "data-name": "Path 12363",
    d: "M251.7,44h10.5v3.4H251.7V44Z",
    fill: "#19c"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoArCintellicareEstesoNopaddingBlue);
export default __webpack_public_path__ + "static/media/Logo_ARCintellicare_esteso_nopadding_Blue.5afc987bbfb398365f191da0bb78b388.svg";
export { ForwardRef as ReactComponent };